export default __webpack_public_path__ + "vuerp/static/img/404.68a8716.png";